module.exports = __webpack_public_path__ + "img/unknown-email.52140d4f.svg";